module.exports = __webpack_public_path__ + "img/hr-pipe-t-left.764ceace.png";